import React from "react";

const NavLink = ({ onClick, active, children }) => (
  <button
    onClick={onClick}
    style={{
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "0.375rem 0.75rem",
      fontSize: "0.875rem",
      fontWeight: 500,
      borderRadius: "8px",
      transition: "color 0.15s",
      color: active ? "#4f46e5" : "#6b7280",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.color = "#4f46e5";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.color = active ? "#4f46e5" : "#6b7280";
    }}
  >
    {children}
  </button>
);

const LoginNav = ({ navigateTo, currentScreen }) => (
  <nav
    style={{
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      background: "rgba(255,255,255,0.75)",
      borderBottom: "1px solid rgba(229,231,235,0.6)",
    }}
    className="mb-4"
  >
    <div
      style={{
        height: "3.5rem",
        display: "flex",
        alignItems: "center",
        maxWidth: "72rem",
        margin: "0 auto",
        padding: "0 1rem",
        position: "relative",
      }}
    >
      {/* Logo — left side, only on non-login pages */}
      {currentScreen !== "login" && (
        <div style={{ position: "relative", display: "inline-flex" }}>
          <div
            onClick={() => navigateTo("login")}
            className="applicant-logo-mini cursor-pointer"
          ></div>
        </div>
      )}

      {/* Tabs — always centered */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "0.25rem",
        }}
      >
        <NavLink
          onClick={() => navigateTo("features")}
          active={currentScreen === "features"}
        >
          Features
        </NavLink>
        <NavLink
          onClick={() => navigateTo("referral")}
          active={currentScreen === "referral"}
        >
          Referral
        </NavLink>
        <NavLink
          onClick={() => navigateTo("help")}
          active={currentScreen === "help"}
        >
          Help
        </NavLink>
      </div>
      <div className="logo-beta-badge" />
    </div>
  </nav>
);

export default LoginNav;
